//
//

import { mapGetters, mapMutations, mapActions } from "vuex";
import { date } from "quasar";
import RuleTesting from "@/components/Diagrams/RuleTesting/RuleTesting.vue";
import DiagramWrapper from "@/components/Diagram/DiagramWrapper/DiagramWrapper.vue";
import PluginContainer from "@/components/Diagram/PluginContainer/PluginContainer.vue";
import PluginSidebar from "@/components/Diagram/PluginSidebar/PluginSidebar.vue";
import CollapsableContainer from "@/components/Diagram/CollapsableContainer/CollapsableContainer.vue";
import pluginDescription from "@/components/Diagrams/sidebar/plugin-description.vue";
import canvasElements from "@/components/Diagrams/sidebar/canvas-elements.vue";
import { PLUGIN_CATEGORIES } from "@/components/Diagram/const/plugin-categories";
import { $http, eventBus, editProcessPermissions, publishAppPermissions, infoToastPublish } from "@/assets/js/appFunc";

export default {
    name: "Diagrams",
    components: {
        RuleTesting,
        DiagramWrapper,
        PluginContainer,
        PluginSidebar,
        CollapsableContainer,
        pluginDescription,
        canvasElements
    },
    data() {
        return {
            openCollapsible: false,
            pageName: "Diagrams",
            refreshDiagram: false,
            readonly: false,
            alreadyMounted: false,
            wasConnectorDblClick: false,
            unNamedConnectorsUUID: [],
            warningsList: [],
            isError: false,
            pluginDescriptionCard: false,
            isConnSelectWarning: false,
            selectedConnUuid: null,
            notifyUpdate: null,
            diagramWarnings: []
        };
    },
    computed: {
        ...mapGetters("diagrams", [
            "selectedPluginConfigData",
            "selectedPluginUuid",
            "diagramConfigData",
            "diagramData",
            "configCache",
            "scDetailsEvent",
            "scDetailsFunction",
            "getWarningsList",
            "getDiagramStateModifications",
            "copyOfInitialContentDiagram",
            "copyOfInitialMessagesDiagam",
            "copyOfInitialConnectorsDiagram",
            "getProcessWithError"
        ]),
        ...mapGetters("rules", ["showRuleTesting"]),
        ...mapGetters("apps", ["apps", "currentApp", "currentProcess", "processList", "getCurrentAppUserPermissions"]),
        ...mapGetters("main", ["getCurrentApplicationId", "getCurrentProcessId", "getDisableOnLoad"]),
        pluginCategories() {
            const plugins = [...PLUGIN_CATEGORIES];

            plugins.forEach(el => {
                el.plugins.forEach(plugin => {
                    if (plugin.id === "BLOCKCHAIN_PLUGIN" || plugin.id === "BLOCKCHAIN_EVENT_PLUGIN" || plugin.id === "START_BLOCKCHAIN_EVENT_PLUGIN") {
                        plugin.displayPreview = this.currentApp.blockchainEnabled;
                    }
                });
            });

            return plugins;
        },
        data: {
            get() {
                return {};
            },
            set(data) {
                if (data && (data.content || data.connectors)) {
                    this.$store.commit("diagrams/diagramData", data);
                }
            }
        },
        config() {
            return { readonly: this.readonly };
        }
    },
    watch: {
        "selectedPluginConfigData.label": {
            handler(v) {
                this.$refs.diagram.updatePluginLabel(this.selectedPluginUuid, v);
                if (this.selectedPluginConfigData.pluginType === "BLOCKCHAIN_EVENT_PLUGIN" && this.scDetailsEvent && !this.scDetailsEvent.length) {
                    this.getBlockchainData("EVENT");
                }
                if (this.selectedPluginConfigData.pluginType === "BLOCKCHAIN_PLUGIN" && this.scDetailsFunction && !this.scDetailsFunction.length) {
                    this.getBlockchainData("FUNCTION");
                }
            }
        },
        "$backendWebsocketEvents.state.diagramChanged": function (actionDetails) {
            if (actionDetails) {
                const wsProcessId = actionDetails.data.split(":")[2];
                const processName = actionDetails.data.split(":")[4];
                if (!sessionStorage.getItem("wsActionUser") && this.$route.name === "diagrams" && wsProcessId === this.getCurrentProcessId) {
                    if (!this.notifyUpdate) {
                        this.notifyUpdate = this.$toast.showNotify({
                            type: "info",
                            buttonLabel: `${this.$t("documents.refresh")}`,
                            message: this.$t("processes.processUpdatedRefresh", { name: processName }),
                            hasClose: false,
                            timeout: 0,
                            actionEvent: this.refreshPage
                        });
                    }
                }
            }
            sessionStorage.removeItem("wsActionUser");
            this.$backendWebsocketEvents.state.refreshProcessList = null;
        },
        getCurrentApplicationId() {
            this.refreshDiagram = true;
        },
        getWarningsList(val) {
            this.warningsList = val;
        },
        getDiagramStateModifications: {
            handler(val) {
                if (val.length) {
                    this.$root.$emit("showCheckedSaveBtn", false);
                }
            },
            immediate: true,
            deep: true
        },
        diagramConfigData: {
            handler(val) {
                if (this.$router.currentRoute.path !== "/customDataViews") {
                    this.$root.$emit("showCheckedSaveBtn", val.content.length > 0);
                }
                const formatActualDiagram = JSON.stringify(val.content);
                const formatActualDiagramConnectors = JSON.stringify(val.connectors);
                const formatActualDiagramMessage = JSON.stringify(val.messages);
                if (this.copyOfInitialContentDiagram && this.copyOfInitialContentDiagram !== formatActualDiagram) {
                    this.$root.$emit("showCheckedSaveBtn", false);
                }
                if (this.copyOfInitialConnectorsDiagram && this.copyOfInitialConnectorsDiagram !== formatActualDiagramConnectors) {
                    this.$root.$emit("showCheckedSaveBtn", false);
                }
                if (this.copyOfInitialMessagesDiagam && this.copyOfInitialMessagesDiagam !== formatActualDiagramMessage) {
                    this.$root.$emit("showCheckedSaveBtn", false);
                }
            },
            deep: true
        },
        getProcessWithError: {
            handler() {
                const checkErrorId = this.getProcessWithError && this.getProcessWithError.id === this.currentProcess.id;
                this.isError = checkErrorId;
                this.pluginDescriptionCard = checkErrorId;
            }
        },
        currentProcess: {
            handler() {
                this.DIAGRAM_VIEW_INITIALIZED();
                const checkErrorId = this.getProcessWithError && this.getProcessWithError.id === this.currentProcess.id;
                this.isError = checkErrorId;
                this.pluginDescriptionCard = checkErrorId;
                this.alreadyMounted = true;
            },
            deep: true
        }
    },
    activated() {
        this.isError = this.getProcessWithError && this.getProcessWithError.id === this.currentProcess.id;
        if (this.isError) {
            this.pluginDescriptionCard = true;
        }
        const readonlyPermissOrMarked = (this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly)
            || this.currentProcess.markedForArchive;
        this.$store.commit("main/setSaveBtnVisible", readonlyPermissOrMarked);
        this.$root.$emit("setReadonlyTag", readonlyPermissOrMarked);
        this.getAppProcesses({ applicationId: this.currentApp.id, searchTerm: "" }).then(rsp => {
            if (rsp.data) {
                const copyOfRsp = [...rsp.data];
                this.$store.commit("apps/setProcessList", copyOfRsp);
                this.$root.$emit("showPublish", { noProcesses: !this.processList.length,
                    showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            }
        });
        this.$store.commit("rules/setShowInstanceTable", false);
        this.$store.commit("rules/setShowRuleTesting", false);
        if (!this.alreadyMounted) {
            this.DIAGRAM_VIEW_INITIALIZED();
        } else {
            this.alreadyMounted = false;
        }
        this.$root.$on("backendWebsocketEvents-publishedApp", data => {
            infoToastPublish(data);
            this.$root.$emit("changePublishError");
        });
    },
    mounted() {
        // TODO: used for testing purpouses. Don't delete it just yet :)
        if (process.env.NODE_ENV === "development") {
            window.referenceToDiagramWrapper = this.$refs.diagram;
            window.referenceToStore = this.$store;
        }
        this.alreadyMounted = true;
    },
    deactivated() {
        this.$root.$off("backendWebsocketEvents-publishedApp");
        if (this.readonly) {
            this.readonly = false;
            this.$refs.diagram.setReadonly(this.readonly);
        }
        this.$store.commit("diagrams/setCopyOfInitialContentDiagram", []);
        this.$store.commit("diagrams/setCopyOfInitialConnectorsDiagram", []);
        this.$store.commit("diagrams/setCopyOfInitialMessagesDiagam", []);
        this.$store.commit("rules/setShowRuleTesting", false);
        this.$refs.diagram.selectPlugin();
        this.pluginDescriptionCard = false;
        this.isError = false;
        if (this.notifyUpdate) {
            this.notifyUpdate();
            this.notifyUpdate = null;
        }
        this.$store.commit("main/setSaveBtnVisible", false);
        this.$root.$emit("setReadonlyTag", false);
    },
    created() {
        this.$store.dispatch("diagrams/getDiagramPlugins");

        eventBus.$on("addConnector", data => {
            data.callback(this.$refs.diagram.addConnector(data.from, data.to));
        });

        eventBus.$on("deleteConnector", uuid => {
            this.$refs.diagram.deleteConnector(uuid);
        });

        eventBus.$on("updateDesignPlugin", data => {
            this.$refs.diagram.updatePluginDesign(data);
        });

        eventBus.$on("addConnectorLabel", data => {
            this.$refs.diagram.updateConnectorLabel(data.uuid, data.label);
        });

        this.$root.$on("diagramsSave", (val) => {
            this.$store.commit("main/setInterfaceDirty", false);
            this.save(val);
        });
        this.$root.$on("oneAtATime-diagrams", oneAtATime => {
            const data = { readonly: !this.$oneAtATime.state.$currentRoomEmpty, oneAtATime: !oneAtATime };
            if ((this.readonly && this.$oneAtATime.state.$currentRoomEmpty) || !this.$oneAtATime.state.$currentRoomEmpty) {
                this.DIAGRAM_VIEW_INITIALIZED(data); // refresh diagram
            } else {
                this.checkPermissions(data);
            }
        });
        this.$root.$off("hideUpdateNotify");
        this.$root.$on("hideUpdateNotify", () => {
            if (this.notifyUpdate) {
                this.notifyUpdate(); // dismiss toast
            }
        });
        this.$root.$off("expandErrorCard");
        this.$root.$on("expandErrorCard", value => {
            this.isError = value;
        });
    },
    methods: {
        ...mapMutations("rules", ["setShowRuleTesting", "setShowInstanceTable"]),
        ...mapMutations("apps", ["updateCurrentAppStatus"]),
        ...mapMutations("main", ["setInterfaceDirty", "setDisableOnLoad"]),
        ...mapMutations("diagrams", [
            "setLastPluginCreated",
            "setConnectorsValidation",
            "checkConnectorsUUIDs",
            "setCopyOfInitialContentDiagram",
            "setSCDetailsFunction",
            "setSCDetailsEvent",
            "copyOfInitialContentDiagram"
        ]),
        ...mapActions("diagrams", ["getScDetails"]),
        ...mapActions("apps", ["getAppProcesses"]),
        editProcessPermissions,
        publishAppPermissions,
        getDiagramWarnings(data) {
            this.diagramWarnings = data || [];
            if (this.pluginDescriptionCard) {
                this.$nextTick(() => {
                    eventBus.$emit("resetMaxHeight", this.$refs.errorPanelRef);
                });
            }
        },
        afterShow() {
            eventBus.$emit("resetMaxHeight", this.$refs.errorPanelRef);
        },

        updateLabel(v) {
            this.$refs.diagram.updatePluginLabel(v.uuid, v.value);
            this.$store.commit("diagrams/setConfigData", v);
        },
        getBlockchainData(param) {
            const obj = {
                param,
                responseNull: true
            };
            this.getScDetails(obj);
        },
        eventEmitted(event) {
            this.$store.commit("diagrams/selectedPluginCode", event.id);
        },
        selectPlugin(plugin) {
            if (plugin && plugin.uuid) {
                this.$store.commit("diagrams/selectedPluginUuid", plugin.uuid);
                this.$store.commit("diagrams/selectedPluginCode", plugin.id);
                this.$refs.diagram.selectPlugin(plugin.uuid);
            }
        },
        cleanExpirationRules(connectorsFrom) {
            connectorsFrom.forEach(connector => {
                const activityToDelete = this.diagramConfigData.content.find((activity) => connector === activity.uuid && activity.expiration);
                if (activityToDelete) {
                    delete activityToDelete.expiration;
                }
            });
        },
        cleanExclusiveGatewayRules(connectorFrom, connectorUuid) {
            const { content } = this.diagramConfigData;
            const PLUGIN = "EXCLUSIVE_GATEWAY_PLUGIN";
            const activity = content.find(({ uuid, pluginType, exclusiveGatewayRoutes }) => exclusiveGatewayRoutes && uuid === connectorFrom
            && pluginType === PLUGIN);
            if (activity) {
                const gwRuleIndex = activity.exclusiveGatewayRoutes.findIndex(({ connectorId }) => connectorId === connectorUuid);
                if (gwRuleIndex !== -1) {
                    activity.exclusiveGatewayRoutes.splice(gwRuleIndex, 1);
                }
            }
        },
        DIAGRAM_VIEW_INITIALIZED(data) {
            const vm = this;
            this.setDisableOnLoad(true);

            vm.$store.commit("diagrams/selectedPluginCode", null);
            vm.$store.commit("diagrams/selectedPluginUuid", null);
            vm.$store.commit("diagrams/configCache", {
                connectors: {},
                content: {}
            });

            vm.$store.dispatch("diagrams/getDataJson").then(() => {
                vm.checkGeneralStartRecurrence();
                vm.$refs.diagram.changeDataSet(vm.diagramData);
                vm.refreshDiagram = false;
                vm.checkPermissions(data);
                this.setDisableOnLoad(false);
            });
        },
        PLUGIN_SELECTED(data) {
            if (data.payload.PLUGIN_ID) {
                this.$store.commit(
                    "diagrams/selectedPluginCode",
                    data.payload.PLUGIN_ID
                );
                this.$store.commit(
                    "diagrams/selectedPluginUuid",
                    data.payload.PLUGIN_UUID
                );
                this.$refs.canvasElements.$emit("changeSelectedTab", "details");
                this.$store.commit("diagrams/setLastPluginCreated", data);
                this.openCollapsible = true;
            } else if (!this.isConnSelectWarning) {
                this.$store.commit("diagrams/selectedPluginUuid", null);
            }
        },
        CONNECTOR_SELECTED(data) {
            const vm = this;

            if (data.payload.FROM_UUID) {
                vm.$store.commit("diagrams/selectedPluginCode", data.payload.FROM_ID);
                vm.$store.commit("diagrams/selectedPluginUuid", data.payload.FROM_UUID);
                if (!this.wasConnectorDblClick && this.selectedConnUuid === data.payload.CONNECTOR_UUID) {
                    this.isConnSelectWarning = true;
                }
                // all of this is added because the diagram sends both CONNECTOR_SELECTED and CONNECTOR_DBLCLICK_SELECTED events

                vm.$nextTick(() => {
                    setTimeout(() => {
                        // need to wait for CONNECTOR_DBLCLICK_SELECTED
                        if (!this.wasConnectorDblClick) {
                            vm.$refs.canvasElements.$emit("changeSelectedTab", "targets");

                            // need to wait for targets tab to be loaded
                            let selector = null;
                            let interval = null;
                            interval = setInterval(() => {
                                if (document.getElementById("targetsList")) {
                                    clearInterval(interval);
                                    selector = document.getElementById(
                                        "targetsList"
                                    );
                                    const element = selector.querySelector(
                                        `label[data-uid="${
                                            data.payload.CONNECTOR_UUID
                                        }"]`
                                    );
                                    if (element) {
                                        if (data.payload.CUSTOM_EVENT_CONN_SELECTED) {
                                            element.classList.add("set-active");
                                        } else {
                                            element.click();
                                        }
                                    }
                                    this.isConnSelectWarning = false;
                                    this.selectedConnUuid = null;
                                }
                            }, 30);
                        }
                    }, 200);
                });
            }
        },
        CONNECTOR_DBLCLICK_SELECTED() {
            this.wasConnectorDblClick = true;
            setTimeout(() => {
                this.wasConnectorDblClick = false;
            }, 1000);
        },
        PLUGIN_CREATED(data) {
            const vm = this;
            let label = data.payload.PLUGIN_LABEL;
            const pluginId = data.payload.PLUGIN_ID;
            vm.$store.commit("diagrams/setLastPluginCreated", data);
            const fromCache = JSON.parse(JSON.stringify(this.configCache.content[data.payload.PLUGIN_UUID] || {}));

            // we should check for duplicates only for new not those from cache
            if (!fromCache.uuid) {
                const duplicates = this.diagramConfigData.content.filter(el => el.label === label || el.pluginType === pluginId);

                if (duplicates.length) {
                    if (duplicates.filter(el => el.label === `${label} ${duplicates.length}`).length) {
                        label += ` (${duplicates.length + 1})`;
                    } else {
                        const lastDuplicatElement = duplicates[duplicates.length - 1];
                        const counter = lastDuplicatElement.label
                            .split("(")
                            .pop()
                            .split(")")[0];
                        if (!counter || Number.isNaN(+counter)) {
                            label += ` (${duplicates.length})`;
                        } else {
                            label += ` (${parseInt(counter, 10) + 1})`;
                        }
                    }
                    vm.$refs.diagram.updatePluginLabel(data.payload.PLUGIN_UUID, label, true);
                }
            }

            vm.$store.commit("diagrams/addNewConfigObject", {
                type: "content",
                payload: {
                    ...{
                        uuid: data.payload.PLUGIN_UUID,
                        label,
                        pluginType: data.payload.PLUGIN_ID
                    },
                    ...fromCache
                }
            });

            // clear cache
            delete this.configCache.content[data.payload.PLUGIN_UUID];
        },
        CONNECTOR_CREATED(data) {
            const vm = this;
            const fromCache = JSON.parse(JSON.stringify(this.configCache.content[data.payload.PLUGIN_UUID] || {}));
            vm.$store.commit("diagrams/addNewConfigObject", {
                type: "connector",
                payload: {
                    ...{
                        uuid: data.payload.CONNECTOR_UUID,
                        label: data.payload.CONNECTOR_LABEL,
                        from: data.payload.FROM_UUID,
                        to: data.payload.TO_UUID
                    },
                    ...fromCache
                }
            });
            // clear cache
            delete this.configCache.connectors[data.payload.PLUGIN_UUID];
        },
        PLUGIN_LABEL_UPDATED(data) {
            const vm = this;

            vm.$store.commit("diagrams/setConfigData", {
                uuid: data.payload.PLUGIN_UUID,
                value: data.payload.LABEL_VALUE,
                property: "label",
                type: "content"
            });
        },
        CONNECTOR_LABEL_UPDATED(data) {
            const vm = this;
            vm.$store.commit("diagrams/checkConnectorsUUIDs", data);
            vm.$store.commit("diagrams/setConfigData", {
                uuid: data.payload.CONNECTOR_UUID,
                value: data.payload.LABEL_VALUE,
                property: "label",
                type: "connector"
            });
            if (vm.unNamedConnectorsUUID.length) {
                vm.unNamedConnectorsUUID.forEach(connector => {
                    vm.$refs.diagram.updatePluginState({ connectorErrorState: true }, connector, false, true);
                });
            }
        },
        PLUGIN_DELETED(data) {
            const vm = this;
            const uuid = data.payload.PLUGIN_UUID;
            const connectorsFrom = [];
            // get all connectors that connect this plugin
            const connectors = vm.diagramConfigData.connectors.filter(el => el.to === uuid);

            // parse all connectors
            connectors.forEach(connector => {
                connectorsFrom.push(connector.from);
                this.cleanExclusiveGatewayRules(connector.from, connector.uuid);
            });
            if (connectorsFrom.length) {
                this.cleanExpirationRules(connectorsFrom);
            }
            // add it to cache before deletion
            this.$store.commit("diagrams/addConfigToCache", {
                type: "content",
                uuid
            });

            vm.diagramConfigData.content = vm.diagramConfigData.content.filter(el => el.uuid !== uuid);
        },
        CONNECTOR_DELETED(data) {
            const vm = this;
            const uuid = data.payload.CONNECTOR_UUID;

            this.cleanExclusiveGatewayRules(data.payload.FROM_UUID, data.payload.CONNECTOR_UUID);

            // add it to cache before deletion
            this.$store.commit("diagrams/addConfigToCache", {
                type: "connectors",
                uuid
            });

            vm.diagramConfigData.connectors = vm.diagramConfigData.connectors.filter(el => el.uuid !== uuid);
        },
        DIAGRAM_STATE_MODIFICATIONS(data) {
            this.$store.commit("diagrams/setDiagramStateModifications", data);
        },
        onDiagramEvent(data) {
            const vm = this;
            if (data.type === "MULTIPLE_ACTIONS_HAPPENED") {
                data.payload.forEach(el => {
                    if (typeof vm[el.event] === "function") {
                        vm[el.event]({ payload: el.payload });
                    }
                });
            } else if (typeof vm[data.type] === "function") {
                vm[data.type](data);
            }
        },
        save(val) {
            const vm = this;
            sessionStorage.setItem("wsActionUser", true);
            return $http(
                {
                    url: `/design/process/diagram/persist?processDefinitionId=${vm.getCurrentProcessId}&applicationId=${vm.getCurrentApplicationId}`,
                    type: "PUT",
                    data: {
                        ...vm.diagramConfigData,
                        diagram: JSON.stringify(vm.$refs.diagram.getDiagramData())
                    }
                },
                true
            )
                .then(data => {
                    this.$store.commit("diagrams/setCopyOfInitialContentDiagram", JSON.stringify(this.diagramConfigData.content));
                    this.$store.commit("diagrams/setCopyOfInitialConnectorsDiagram", JSON.stringify(this.diagramConfigData.connectors));
                    this.$store.commit("diagrams/setCopyOfInitialMessagesDiagam", JSON.stringify(this.diagramConfigData.messages));
                    this.$store.commit("apps/updateCurrentAppStatus", data);
                    this.$store.commit("diagrams/setDiagramStateModifications");
                    const dataWarnings = data.data.warnings && data.data.warnings.length ? data.data.warnings : null;
                    const warnings = [];
                    const diagramData = this.$refs.diagram.getDiagramData();

                    if (dataWarnings) {
                        dataWarnings.forEach(element => {
                            const tooltipNewMesage = element.message.split(element.id);
                            if (element.type === "CONNECTOR") {
                                diagramData.connectors.forEach(el => {
                                    if (el.uuid === element.id) {
                                        element.label = el.label.value ? `"${el.label.value}" ${this.$t("diagrams.connectorType")}`
                                            : this.$t("diagrams.untitledConnector");
                                    }
                                });
                                element.tooltip = this.$t("diagrams.connectorType") + (tooltipNewMesage.length
                                    ? tooltipNewMesage[tooltipNewMesage.length - 1] : "");
                            } else {
                                let warningPluginLabel = "";
                                if (diagramData && diagramData.content) {
                                    warningPluginLabel = diagramData.content.find(elem => elem.uuid === element.id);
                                }
                                element.label = warningPluginLabel.label.value || "";
                                element.tooltip = element.label && tooltipNewMesage.length ? element.label + tooltipNewMesage[tooltipNewMesage.length - 1] : "";
                            }
                            warnings.push(element);
                        });
                    }
                    this.$store.commit("diagrams/setWarningsList", warnings);
                    this.currentApp.publishStatus = data.data.status ? "UNPUBLISHED_CHANGES" : "PUBLISHED";
                    this.$store.commit("apps/setCurrentApp", this.currentApp);
                    if (val) {
                        this.$root.$emit("savedSuccessfully");
                    }
                    vm.$toast.showNotify({
                        type: "success",
                        message: this.$t("generic.savedSuccessfully")
                    });
                })
                .catch(e => {
                    sessionStorage.removeItem("wsActionUser");
                    vm.$toast.showNotify({
                        type: "error",
                        message: e.response.data.error
                    });
                });
        },
        onKeyUp(ev) {
            // Undo & Redo
            const emitEvents = true;
            if (ev.ctrlKey && ev.keyCode === 90) {
                // ctrl + Z
                this.$refs.diagram.undoState(emitEvents);
            } else if (ev.ctrlKey && ev.keyCode === 89) {
                // ctrl + Y
                this.$refs.diagram.redoState(emitEvents);
            }
        },
        openCurrentConnector(connUuid) {
            const selector = document.getElementById("targetsList");
            const element = selector ? selector.querySelector(`label[data-uid="${connUuid}"]`) : null;
            if (element) {
                element.click();
            } else {
                if (this.selectedPluginUuid) {
                    this.$store.commit("diagrams/selectedPluginCode", null);
                    this.$store.commit("diagrams/selectedPluginUuid", null);
                    this.$refs.diagram.selectPlugin(null);
                }
                this.$nextTick(() => {
                    this.selectedConnUuid = connUuid;
                    this.$refs.diagram.selectConnector(connUuid, true);
                });
            }
        },
        openCurrentPlugin(pluginUuid) {
            this.$refs.diagram.selectPlugin(pluginUuid, null, true);
        },
        checkGeneralStartRecurrence() {
            if (this.diagramConfigData && this.diagramConfigData.content) {
                this.diagramConfigData.content.forEach(element => {
                    if (element.pluginType === "GENERAL_START_PLUGIN") {
                        if (element.recurrence && element.recurrence.endDate) {
                            const newDate = new Date();
                            const recurrenceDate = new Date(element.recurrence.endDate);
                            const diff = date.getDateDiff(recurrenceDate, newDate, "days");
                            if (diff < 0) {
                                for (let i = 0; i < this.diagramData.content.length; i++) {
                                    const plugin = this.diagramData.content[i];
                                    if (plugin.uuid === element.uuid && plugin.label.additionalOptions) {
                                        plugin.label.additionalOptions = { ...plugin.label.additionalOptions, recurrenceExpired: true };
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    const index = this.diagramData.content.findIndex(item => item.uuid === element.uuid && item.label.value !== element.label);
                    if (index !== -1) {
                        this.diagramData.content[index].label.value = element.label;
                    }
                });
            }
        },
        checkPermissions(oneAtATimeParams) {
            const { params } = this.$route;
            const isReadonly = (params && ((params.permissions && params.permissions.readonly) || params.isMarkedForArchiving))
            || this.currentProcess.markedForArchive;
            if (isReadonly) {
                this.readonly = true;
                this.$store.commit("main/setSaveBtnVisible", this.readonly);
                this.$root.$emit("setReadonlyTag", this.readonly);
                this.$refs.diagram.setReadonly(this.readonly, false, true);
            } else if (oneAtATimeParams && oneAtATimeParams.hasOwnProperty("readonly")) {
                this.readonly = oneAtATimeParams.readonly;
                this.$store.commit("main/setSaveBtnVisible", this.readonly);
                this.$root.$emit("setReadonlyTag", this.readonly);
                this.$refs.diagram.setReadonly(this.readonly, oneAtATimeParams.oneAtATime);
            } else {
                this.readonly = false;
                this.$store.commit("main/setSaveBtnVisible", this.readonly);
                this.$root.$emit("setReadonlyTag", this.readonly);
                this.$refs.diagram.setReadonly(this.readonly);
            }
        },
        resetDiagramData() {
            const defaultDiagramData = {
                connectors: [],
                content: [],
                worldData: {
                    height: 2200,
                    width: 2000
                },
                gridView: {
                    cellHeight: 100,
                    cellWidth: 100,
                    cols: 10,
                    padding: 500,
                    rows: 12
                }
            };
            this.$refs.diagram.changeDataSet(defaultDiagramData);
            this.$refs.diagram.resetZoom();
        },
        refreshPage() {
            window.location.reload();
        }
    }

};
